module.exports = __webpack_public_path__ + "static/img/modal_bg1.59c643b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/modal_bg1.png
// module id = HGxY
// module chunks = 1